import { loader } from 'graphql.macro';
import { useQuery } from '@apollo/client';
import { get } from 'lodash';

import { useNotificationContext } from '../context/notification-context';
import { CompanyType } from '../definitions.d';

const COMPANY_QUERY = loader('../graphql/company.graphql');

interface CompaniesQueryResponse {
  company?: CompanyType;
  loading?: boolean;
  error?: Error;
}

const useCompanyQuery = (uuid: string): CompaniesQueryResponse => {
  const { showNotification } = useNotificationContext();
  const { data, loading, error } = useQuery(COMPANY_QUERY, {
    variables: { uuid },
    fetchPolicy: 'network-only',
    onError: (e) => {
      showNotification(e.message, 'error');
    }
  });
  return { company: get(data, 'company'), loading, error };
};

export default useCompanyQuery;
